const { createTheme, responsiveFontSizes } = require('@mui/material/styles')
const colors = require('./theme/colors')

/**
 * @typedef {import('@mui/material/styles').ThemeOptions}
 */

export { colors }

let theme = createTheme({
  transitions: {
    duration: {
      standard: 350,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  palette: {
    primary: {
      main: '#F0DE2A',
      light: '#F0DE2A',
      contrastText: '#242222',
    },
    secondary: {
      main: '#712279',
      contrastText: '#fff',
    },
    error: {
      main: '#8F0000',
      light: '#C10000',
    },
  },
  typography: {
    fontFamily: [
      '"Archivo"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Roboto"',
      '"Helvetica Neue"',
      '"Arial"',
      'sans-serif',
    ].join(','),
  },
})

theme = responsiveFontSizes(theme)

export default theme
